
const TokenKey = 'token'

export function getToken() {
  return window.localStorage.getItem('token')
}

export function setToken(token) {
  return window.localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return window.localStorage.clear(TokenKey)
}
